<template>
  <v-container>
    <material-card
      :title="Item.title"
      :text="Item.subTitle"
      color="green"> 
      <v-form
      ref="form"
      v-model="valid"
      lazy-validation>
        <v-container py-0>
          <v-layout wrap>
            <!-- <h4>{{ ProgressBar }}</h4> -->
            <v-flex md12 v-if="DisableButton"> 
            <div class="progress_parent">
              <b class="textCenter"> {{ ProgressBar < 100 ? ProgressBar + ' %' : 'Processing' }}</b>
              <div class="progress_child" :style="{'width': ProgressBar + '%'}">
              </div>
            </div>
            </v-flex>
            <v-flex  :class="[Item.width]">
              <v-text-field type="text"
                label="Title"
                class="green-input"
                 v-model="lecture.title"
                  prepend-icon='text_fields'
                 :rules="titleRule"/>
                 
            </v-flex>
            <v-flex  :class="[Item.width]">
              <v-text-field type="text"
                label="Title Bangla"
                class="green-input"
                 v-model="lecture.title_bn"
                  prepend-icon='text_fields'
                 :rules="titleBnRule"/>
                 
            </v-flex>
            <v-flex md12>
              <v-text-field type="text" 
                label="Description"
                class="green-input"
                 v-model="lecture.description"
                  prepend-icon='description'
                 />
                 
            </v-flex>
            <v-flex  :class="[Item.width]">
              
         <v-text-field label="Lecture Video" @click='pickFile' prepend-icon='attach_file' v-model="lectureVideoName" class="green-input"></v-text-field>
					<input
						type="file"
						style="display: none"
						ref="lectureVideo"
						accept="video/*"
						@change="onFilePicked"
                 :rules="lectureVideoRule"
					>
            
            </v-flex>
            <v-flex  :class="[Item.width]">
              
            <v-text-field  v-model="thumbnailName" label="Thumbnail" @click='pickThumbnail' prepend-icon='attach_file' class="green-input"></v-text-field>
					<input
						type="file"
						style="display: none"
						ref="thumbnail"
						accept="image/*"
						@change="onThumbnailPicked"
            :rules="thumbnailRule"
					>
            </v-flex>

            <v-flex  :class="[Item.width]">
              <v-text-field type="number" 
                label="Price"
                class="green-input"
                 v-model="lecture.price"
                  prepend-icon='attach_money'
                 :rules="priceRule"/>
                 
            </v-flex>
            <v-flex
              xs12
              text-xs-right>
              <v-btn
                :disabled="DisableButton"
                class="mx-0 font-weight-light"
                color="success" @click="onClickButton">{{ Item.submitText }}</v-btn>
            </v-flex> 
          </v-layout>
        </v-container>
      </v-form>
    </material-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    // title: String,
    Item: Object,
    Value: Object,
    DisableButton: Boolean,
    ProgressBar: Number,
  },
  computed: {
    ...mapState("course_subjects", [
      "question",
    ])
  },
  data () {
      return {
          valid: true,
          lecture: {},
          lectureVideoName: '',
          thumbnailName: '',
          titleRule: [
            v => !!v || 'Title is required.'
          ],
          titleBnRule: [
            v => !!v || 'Title Bangla is required.'
          ],
          lectureVideoRule: [
            v => !!v || 'Video is required.'
          ],
          thumbnailRule: [
            v => !!v || 'Thumbnail is required.'
          ],
          durationRule: [],
          priceRule: [
            v => !!v || 'Price is required.'
          ],
        
      }
  },
  created () {
    this.lecture = {}
    this.lecture = this.Value
  },
  methods: {
     pickFile () {
            this.$refs.lectureVideo.click ()
     },
     pickThumbnail () {
            this.$refs.thumbnail.click ()
            
     },
	  onThumbnailPicked (e) {
      this.thumbnailName = e.target.files[0].name
   },
	  onFilePicked (e) {
      this.lectureVideoName = e.target.files[0].name
   },
    onClickButton (event) {
      this.lecture.course_id = this.question.course_id
      this.lecture.subject_id = this.question.subject_id
      this.lecture.chapter_id = this.question.chapter_id
    let lectureVideo = this.$refs.lectureVideo.files[0]
    let thumbnail = this.$refs.thumbnail.files[0]
        if (this.$refs.form.validate()) {
          this.lecture.status = 'Available'
          var formData = new FormData();
          formData.append('data', JSON.stringify(this.lecture))
          formData.append('lectureVideo', lectureVideo);
          formData.append('thumbnail', thumbnail);
  
          this.$emit('emitted', formData)
        } else {
          console.log('Second')
        }
    }
  }
}
</script>
<style  scoped>
.progress_parent, .progress_child {
  height: 20px;
  border-radius: 5px;
}
.progress_parent {
  width: 100%;
  background: #efecec;
}
.progress_child {
  background: #ccb300;
  -webkit-transition: width .5s; /* For Safari 3.1 to 6.0 */
  transition: width .52s;
}
.textCenter {
  position: fixed;
  left: 48%;
  margin-top: 2px;
}
</style>